import type { MapDataGameCoordinates } from '@repo/types/maps/map-types';
import { useCallback, useEffect, useRef, useState } from 'react';
interface AskAnythingPinContext {
  id: string;
  name: string;
  category?: string;
  subcategory?: string;
  coordinates: [number, number];
  gameCoords?: MapDataGameCoordinates | null;
}
interface AskAnythingResponse {
  answer?: string;
  pinIds?: string[];
}
export function useAskAnythingStub() {
  const [isLoading, setIsLoading] = useState(false);
  const isMountedRef = useRef(true);
  useEffect(() => () => {
    isMountedRef.current = false;
  }, []);
  const submit = useCallback(async (query: string, pin: AskAnythingPinContext): Promise<AskAnythingResponse> => {
    setIsLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 350));
      return {
        answer: `Placeholder results for "${query}" near ${pin.name}.`,
        pinIds: [pin.id]
      };
    } finally {
      if (isMountedRef.current) {
        setIsLoading(false);
      }
    }
  }, []);
  return {
    submit,
    isLoading
  };
}